export interface ISendMotivationalNudgeRequest {
    userIds: number[];
    sendPush: boolean;
    sendEmail: boolean;
    title: string;
    body: string;
    imageId?: number;
}

export interface IMotivationalNudgeImage {
    id: number;
    description: string;
    imageUrl: string;
}

export interface ISendMotivationalNudgeResult {
    campaignId: string;
    recipientCount: number;
    failedAttemptCount: number;
    undeliverableCount: number;
}

export interface IMotivationalNudgeState {
    sending: boolean;
    error: string | null;
}

export const initialMotivationalNudgeState: IMotivationalNudgeState = {
    sending: false,
    error: null,
};
